import { NavigationGuard } from "vue-router";
import Auth from "@/utils/auth";

export const AdminGuard: NavigationGuard = (to, from, next) => {
  const redirect: string = to.name as string;
  Auth.refresh ? next() : next({ name: "login", query: { redirect } });
};
